import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InlineTableService } from '@morningstar/shared/base/base-service/inline-table-service';
import { Todo } from './todo';

@Injectable()
export class TodoService extends InlineTableService<Todo> {

  dataDescription = 'todo';
  baseEndpoint = 'dashboard/check-list';

  constructor(protected snackbar: MatSnackBar, 
              protected httpClient: HttpClient,
              @Inject('API_BASE_URL') protected baseUrl: string) {
    super(snackbar, httpClient, baseUrl);
  }
}
